import React from "react";
import { Image_Url } from '../../constants/imageUrl/ImageUrl'
import Header from "../../component/Header/Header";
import Footer from "../../component/Footer/Footer";
import Sidebar from "../Sidebar";
import "./pgmdealers.scss";
function PgmDealers() {
  return (
    <>
      <Header/>
    
    <div className="pgmdealers_container">
       
      <div className="sidebar"><Sidebar/></div>
      
      <div className="pgmlistmain">
      
       <div className="header_border">
        {/* <span>TVS  <img />  Dashboard</span> */}
        <img src={Image_Url.TVSDASHBOARD}/>
       </div>
        <div className="pgmdealers_text">
          <span className="dealers_text">Dealers</span>
          <button className="dealers_button">Add new dealer</button>
        </div>
        <div className="pgmlistdropdown_textfield">
          <div className="pgmlistdropdown_div">
            <div class="input-wrapper">
              <label for="first">Province/ State</label>
              <select>
                <option value=""></option>
                <option value="1">Audi</option>
                <option value="2">BMW</option>
                <option value="3">Citroen</option>
              </select>
            </div>
          </div>
          <div className="pgmlistdropdown_div">
            <div class="input-wrapper">
              <label for="first">City</label>
              <select>
                <option value=""></option>
                <option value="1">Audi</option>
                <option value="2">BMW</option>
                <option value="3">Citroen</option>
              </select>
            </div>
          </div>
          <div className="pgmlistdropdown_div">
            <div class="input-wrapper">
              <label for="search">Search</label>
              <input type="text" />
            </div>
          </div>
          {/* <div className="button_div"> */}
            <button className="button_search"> Search</button>
          {/* </div> */}
        </div>
        <div>
        <div className="tabledata">
                  <table className="table">
                    <tr>
                      <th className="tablesth">Sr no.</th>
                      <th className="tablesth">Dealers Name</th>
                      <th className="tablesth">Dealers type</th>
                      <th className="tablesth">Address</th>
                      <th className="tablesth">Phone</th>
                      <th className="tablesth"></th>
                    </tr>
                        <tr>
                          <td className="tabletd">1</td>
                          <td className="tabletd">DPM Motors</td>
                          <td className="tabletd">2w & 3w</td>
                          <td className="tabletd">Ladpur,Dehradun</td>
                          <td className="tabletd">7905942873</td>
                          <td className="tabletd_view">View</td>
                        </tr>
                        <tr>
                          <td className="tabletd">2</td>
                          <td className="tabletd">DPM Motors</td>
                          <td className="tabletd">2w & 3w</td>
                          <td className="tabletd">Ladpur,Dehradun</td>
                          <td className="tabletd">7905942873</td>
                          <td className="tabletd_view">View</td>
                        </tr>
                        <tr>
                          <td className="tabletd">3</td>
                          <td className="tabletd">DPM Motors</td>
                          <td className="tabletd">2w & 3w</td>
                          <td className="tabletd">Ladpur,Dehradun</td>
                          <td className="tabletd">7905942873</td>
                          <td className="tabletd_view">View</td>
                        </tr>
                        <tr>
                          <td className="tabletd">4</td>
                          <td className="tabletd">DPM Motors</td>
                          <td className="tabletd">2w & 3w</td>
                          <td className="tabletd">Ladpur,Dehradun</td>
                          <td className="tabletd">7905942873</td>
                          <td className="tabletd_view">View</td>
                        </tr>
                        <tr>
                          <td className="tabletd">5</td>
                          <td className="tabletd">DPM Motors</td>
                          <td className="tabletd">2w & 3w</td>
                          <td className="tabletd">Ladpur,Dehradun</td>
                          <td className="tabletd">7905942873</td>
                          <td className="tabletd_view">View</td>
                        </tr>
                        <tr>
                          <td className="tabletd">6</td>
                          <td className="tabletd">DPM Motors</td>
                          <td className="tabletd">2w & 3w</td>
                          <td className="tabletd">Ladpur,Dehradun</td>
                          <td className="tabletd">7905942873</td>
                          <td className="tabletd_view">View</td>
                        </tr>
                  </table>
                </div>
        </div>
        <div className="footer_div">
        <Footer />
      </div>
      </div>
    </div>
    
    </>
  );
}

export default PgmDealers;
